// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars, @typescript-eslint/no-explicit-any
export default function noop<Args extends any[]>(..._args: Args) {
	/* empty */
}
